export enum EmailConfirmErrorCode {
  INVALID_OR_EXPIRED_TOKEN = 'INVALID_OR_EXPIRED_TOKEN',
}

export type EmailVerificationResult =
  | {
      success: false;
      errorCode?: EmailConfirmErrorCode;
    }
  | { success: true; memberEmailChangedTo?: string };

export enum EmailChangeErrorCode {
  INVALID_EMAIL = 'INVALID_EMAIL',
  SAME_EMAIL = 'SAME_EMAIL',
  UNKNOWN = 'UNKNOWN',
}

export class EmailChangeError extends Error {
  constructor(
    public readonly code: EmailChangeErrorCode,
    message?: string
  ) {
    super(message || code);
    this.name = 'EmailChangeError';
  }
}
